// export const baseBusinessUrl: string = process.env.REACT_APP_BASE_URL
// export const baseUrl: string = process.env.REACT_APP_BASE_URL

import { apiUrl } from "./constants";


// http://ninportal-backend-qa.apps.non-core-dev.sterlingbank.com/api


export const baseUrl: string = apiUrl;

export const baseBusinessUrl: string = apiUrl;
